import template from './client-detail.html';
import controller from './client-detail.controller';

let clientDetailComponent = {
  bindings: {},
  template,
  controller
};

export default clientDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/client/client-detail.component.js